import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import { IconButton, TextField } from "@mui/material";
import { API } from "../assets/staticData";
import SelectPost from "../components/select-post/SelectPost";
import { GridDeleteIcon } from "@mui/x-data-grid";
import InstructorDataTable from "../components/data-tables/InstructorDataTable";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

export default function Instructor({user}) {
  const [error, setError] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [title, setTitle] = useState("");

  const [sections, setSections] = useState([
    {
      label: "",
      post: {},
    },
  ]);

  useEffect(() => {
    async function getData() {
      fetch(`${API}/instructors`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setPlatforms(respone.data);
      });
    }

    getData();
  }, [refresh]);

  if (error) {

    return <div>An error occured: {error.message}</div>;
  }

  const uploadItem = () => {
    if (sections.length > 1 || title !== "") {
      fetch(`${API}/instructors`, {
        headers,
        method: "POST",
        body: JSON.stringify({
          data: {
            instructorData: sections,
            title: title,
          },
        }),
      })
        .then(() => {
          setSections([
            {
              label: "",
              post: {},
            },
          ]);
          setTitle("");
          setOpenAdd(false);
          setRefresh(!refresh);
          toast("The Item was successfully added", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
        .catch((error) => setError(error));
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  const addNewSection = () => {
    const newSections = [
      ...sections,
      {
        label: "",
        post: {},
      },
    ];
    setSections(newSections);
  };

  const removeSection = (indexToRemove) => {
    const newSections = sections.filter((_, index) => index !== indexToRemove);
    setSections(newSections);
  };

  return (
    <div className="App">
      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>Instructor Settings</h3>
        {user.perms[23].add && (
          <div
            className="addC"
            style={{
              minHeight: openAdd ? "auto" : 50,
              padding: openAdd ? 20 : 0,
            }}
          >
            {openAdd && (
              <div
                className="addContent"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <TextField
                  label="Instructor Title"
                  sx={{ width: "95%", mb: 1 }}
                  size="small"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {sections.map((item, ind) => (
                  <div
                    key={ind}
                    style={{
                      width: "100%",
                      display: "flex",
                      paddingBottom: sections.length > 1 ? 10 : 0,
                      marginBottom: 10,
                      borderBottom:
                        sections.length > 1 ? "1px solid #ddd" : null,
                    }}
                  >
                    <div style={{ width: "50%", height: "100%" }}>
                      <TextField
                        label="Label"
                        sx={{ width: "90%" }}
                        size="small"
                        value={sections[ind].label}
                        onChange={(e) => {
                          setSections([
                            ...sections.map((item, idx) => {
                              if (idx === ind) {
                                return {
                                  ...item,
                                  label: e.target.value,
                                };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                    </div>
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <SelectPost
                        post={sections}
                        setPost={setSections}
                        ind={ind}
                      />
                    </div>

                    {sections.length > 1 && (
                      <IconButton
                        onClick={() => removeSection(ind)}
                        sx={{
                          color: "grey",
                          "&:hover": {
                            color: "red",
                          },
                          transition: "0.2s",
                        }}
                      >
                        <GridDeleteIcon />
                      </IconButton>
                    )}
                  </div>
                ))}

                <div
                  style={{
                    marginTop: 10,
                    background: "green",
                    padding: "5px 25px",
                    borderRadius: 5,
                    color: "#fff",
                    cursor: "pointer",
                    marginBottom: 10,
                  }}
                  onClick={() => addNewSection()}
                >
                  Add Section
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? uploadItem() : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}
            >
              Add a new Instructor
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>

            {openAdd && (
              <div
                onClick={() => {
                  setOpenAdd(false);
                  setSections([
                    {
                      label: "",
                      post: {},
                    },
                  ]);
                  setTitle("");
                }}
                className="cancelBTN"
              >
                Cancel
              </div>
            )}
          </div>
        )}

        <InstructorDataTable data={platforms} endpoint={"instructors"} user={user} />
      </div>
    </div>
  );
}
